function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import MultiChoiceFilter from './MultiChoiceFilter';
export default function SelectFilter(_ref) {
  let {
    dataTestId,
    initialValue = '',
    onFilter,
    options,
    showPlusButton = false,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(MultiChoiceFilter, _extends({
    dataTestId: dataTestId,
    initialValue: initialValue,
    onChange: onFilter,
    options: options,
    showPlusButton: showPlusButton,
    type: "select"
  }, props));
}